import type {ReactNode} from 'react';
import {
    FormControlLabel, Switch as MuiSwitch, SwitchProps as MuiSwitchProps
} from '@material-ui/core';
import classNames from 'classnames';
import {useDesignContext} from '@theme';
import './appSwitch.less';

export type AppSwitchProps = MuiSwitchProps & {
    label?: ReactNode;
};

export const AppSwitch = (props: AppSwitchProps) => {
    const {
        className, disabled, label, ...rest
    } = props;
    const {designVersion} = useDesignContext();
    const containerClassName = classNames('app-switch-container', className, designVersion, {disabled});
    const switchClassName = classNames('switch', {disabled});

    return (
        <FormControlLabel
            classes={{root: containerClassName}}
            disabled={disabled}
            control={(
                <MuiSwitch
                    className={switchClassName}
                    disabled={disabled}
                    {...rest}
                />
            )}
            label={label}

        />
    );
};
